// extracted by mini-css-extract-plugin
module.exports = {"stickyHeader":"Header_stickyHeader__5A7PM","orderNow":"Header_orderNow__srVHI","logo":"Header_logo__h_d_N"};